'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

function generator(props) {
    return function (Basic) {
        return function (_React$Component) {
            (0, _inherits3["default"])(Adapter, _React$Component);

            function Adapter() {
                (0, _classCallCheck3["default"])(this, Adapter);
                return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
            }

            Adapter.prototype.render = function render() {
                var prefixCls = props.prefixCls;

                return _react2["default"].createElement(Basic, (0, _extends3["default"])({ prefixCls: prefixCls }, this.props));
            };

            return Adapter;
        }(_react2["default"].Component);
    };
}

var Basic = function (_React$Component2) {
    (0, _inherits3["default"])(Basic, _React$Component2);

    function Basic() {
        (0, _classCallCheck3["default"])(this, Basic);
        return (0, _possibleConstructorReturn3["default"])(this, _React$Component2.apply(this, arguments));
    }

    Basic.prototype.render = function render() {
        var _a = this.props,
            prefixCls = _a.prefixCls,
            className = _a.className,
            children = _a.children,
            others = __rest(_a, ["prefixCls", "className", "children"]);
        var hasSider = void 0;
        _react2["default"].Children.forEach(children, function (element) {
            if (element && element.type && element.type.__ANT_LAYOUT_SIDER) {
                hasSider = true;
            }
        });
        var divCls = (0, _classnames2["default"])(className, prefixCls, (0, _defineProperty3["default"])({}, prefixCls + '-has-sider', hasSider));
        return _react2["default"].createElement(
            'div',
            (0, _extends3["default"])({ className: divCls }, others),
            children
        );
    };

    return Basic;
}(_react2["default"].Component);

var Layout = generator({
    prefixCls: 'ant-layout'
})(Basic);
var Header = generator({
    prefixCls: 'ant-layout-header'
})(Basic);
var Footer = generator({
    prefixCls: 'ant-layout-footer'
})(Basic);
var Content = generator({
    prefixCls: 'ant-layout-content'
})(Basic);
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
exports["default"] = Layout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/layout/layout.js
// module id = 543
// module chunks = 0